import { useState } from 'react';
import { Users, Calculator, DollarSign, FileEdit, BarChart3, Network, FileSignature } from 'lucide-react';
import AffiliatesList from './affiliates/AffiliatesList';
import AffiliateCalc from './affiliates/AffiliateCalc';
import AffiliatePayments from './affiliates/AffiliatePayments';
import AffiliateAdjustments from './affiliates/AffiliateAdjustments';
import AffiliateReports from './affiliates/AffiliateReports';
import AffiliateTree from './affiliates/AffiliateTree';
import AffiliateApplications from './affiliates/AffiliateApplications';

type AffiliateTab =
  | 'list'
  | 'calc'
  | 'payments'
  | 'adjustments'
  | 'reports'
  | 'tree'
  | 'applications';

const tabs: { id: AffiliateTab; label: string; icon: typeof Users }[] = [
  { id: 'list', label: 'Affiliates', icon: Users },
  { id: 'calc', label: 'Calc', icon: Calculator },
  { id: 'payments', label: 'Pending Payments', icon: DollarSign },
  { id: 'adjustments', label: 'Adjustments', icon: FileEdit },
  { id: 'reports', label: 'Reports', icon: BarChart3 },
  { id: 'tree', label: 'Tree', icon: Network },
  { id: 'applications', label: 'Applications', icon: FileSignature },
];

export default function Affiliates() {
  const [tab, setTab] = useState<AffiliateTab>('list');

  const renderTab = () => {
    switch (tab) {
      case 'list':
        return <AffiliatesList />;
      case 'calc':
        return <AffiliateCalc />;
      case 'payments':
        return <AffiliatePayments />;
      case 'adjustments':
        return <AffiliateAdjustments />;
      case 'reports':
        return <AffiliateReports />;
      case 'tree':
        return <AffiliateTree />;
      case 'applications':
        return <AffiliateApplications />;
      default:
        return <AffiliatesList />;
    }
  };

  return (
    <div>
      {/* Tab nav */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex flex-wrap gap-x-6 gap-y-2">
          {tabs.map((t) => {
            const Icon = t.icon;
            const isActive = tab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`flex items-center gap-2 py-3 px-1 border-b-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon className="w-4 h-4" />
                {t.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Active tab content */}
      <div>{renderTab()}</div>
    </div>
  );
}
